module.exports = __webpack_public_path__ + "img/Wicklmayr2019.db8888dd.jpg";